/* eslint-disable jsx-a11y/anchor-is-valid */
import { PrimaryButton, SecondaryButton } from "Element/Button";
import About from "./About";
import How from "./How";
import InvitationBox from "./InvitationBox";
import Faq from "./Faq";
import LandingContent from "./LandingContent";
import { VerifiedSmartContract } from "./styled";
import Footer from "Component/Footer";
import Inventory from "./Inventory";
import Roadmap from "./Roadmap";

const LandingPage = () => {
  return (
    <>
      <LandingContent />
      <Inventory />
      <About />
      <How />
      <InvitationBox
        title="lets BUY a DOGE "
        desc="The initial sale has concluded. To get your Doge, check out the collection on OpenSea."
        btn1={<PrimaryButton>buy on boxyswap</PrimaryButton>}
      />
      <Roadmap />
      <Faq />
      <InvitationBox
        title="JOIN our community "
        desc=""
        btn1={<PrimaryButton>Join on discord</PrimaryButton>}
        btn2={<SecondaryButton>Follow Twitter</SecondaryButton>}
      />
      <VerifiedSmartContract mb={20} mt={10} gap={8} justifyContent="center">
        VERIFIED SMART CONTRACT :<a href="#"> 0xBC4CA0Esa3CsWWASd...a936f13D</a>
      </VerifiedSmartContract>
      <Footer />
    </>
  );
};

export default LandingPage;
